import { Component, forwardRef, Renderer2, ViewChild, ElementRef, Input, AfterViewInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const EPANDED_TEXTAREA_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ExpandableTextareaComponent),
  multi: true,
};

@Component({
  selector: 'expandable-textarea',
  providers: [EPANDED_TEXTAREA_VALUE_ACCESSOR],
  template: `<div class="expand-textarea" placeholder="" contenteditable="true" #textarea rows="4" id="{{idKey}}" (input)="change($event)" role="textarea"></div>`,
  styles: [`
  .expand-textarea {
    min-height: 90px;
  }
  .expand-textarea[placeholder]:empty:before {
    content: attr(placeholder);
    color: #ccc; 
  }
  .expand-textarea[placeholder]:empty:focus:before {
    content: attr(placeholder);
  }
  `]
})
export class ExpandableTextareaComponent implements ControlValueAccessor, AfterViewInit {
  @ViewChild('textarea') textarea: ElementRef;
  @Input('pH') pH:string; // placeholder input
  @Input('idKey') idKey:string; // placeholder input
  onChange;
  onTouched;
  textPH: any = 'Letter of Credit';
  
  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
  ) { }

  ngOnInit(): void {
  }
  
  ngAfterViewInit() {
    // set placeholder value
    $(`#${this.idKey}`).attr("placeholder", this.pH);
  }

  /*
	* Created By : Sharann N
	* Description : render div in html.
	*********************************************/
  writeValue(value: any): void {
    setTimeout(() => {
      const div = this.textarea.nativeElement;
      this.renderer.setProperty(div, 'textContent', value);
    }, 400);

  }

  /*
	* Created By : Sharann N
	* Description : register `on change` functionality for the rendered html tag.
	*********************************************/
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /*
	* Created By : Sharann N
	* Description : register `touch` functionality for the rendered html tag.
	*********************************************/
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  /*
	* Created By : Sharann N
	* Description : set `disable` attribute for the rendered html tag.
	*********************************************/
  setDisabledState(isDisabled: boolean): void {
    setTimeout(() => {
      isDisabled = false;  //for testing
      const div = this.el.nativeElement;
      const action = isDisabled ? 'addClass' : 'removeClass';
      this.renderer[action](div, 'disabled');
    }, 400);
  }

  /*
	* Created By : Sharann N
	* Description : `on change` functionality for the rendered html tag.
	*********************************************/
  change($event) {
    this.onChange($event.target.textContent);
    this.onTouched($event.target.textContent);
  }

}

// <expandable-textarea [formControl]="control"></expandable-textarea>